export default __webpack_public_path__ + "static/media/gpu.9d76df86.png";